import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { Checkbox, FormHelperText, TextField } from '@material-ui/core';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import FlexView from 'react-flexview/lib';
import { liabilityLimitPretty } from '../../services/utils';
import { useForm } from 'react-hook-form';
import { WorldWideOption } from '../../models/insurance-models/WorldWideOption';

export const WorldWideCoverageeDetailsPopup = () => {
    const [open, setOpen] = React.useState(false);
    const [desc, setDesc] = React.useState('')
    const [limits, setLimits] = React.useState(WorldWideOption.Default)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleDisagree = () => {
        setOpen(false);
    };

    const handleChange = (e) => setDesc(e.target.value)

    const handleAgree = () => {

        EventEmitterService.dispatch(EventKey.WW_DETAILS_POPUP_APPROVE, { limits: limits, description: desc })

        setOpen(false);
        
    };

    React.useEffect(() => {

        let id = EventEmitterService.subscribe(EventKey.SHOW_WW_DETAILS_POPUP, (details) => {
            setDesc(details.description)
            setLimits(details.limits)
            handleClickOpen()
        })

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.SHOW_WW_DETAILS_POPUP, id)
        }
    }, [])

    return (
        <Dialog
            open={open}
            onClose={handleDisagree}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">World Wide Coverage Details</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Please describe the purpose of your travel, e.g business or leisure and to which countries
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    <TextField label={'Description'} name="description" value={desc} onChange={handleChange} fullWidth variant="outlined"  />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleDisagree} color="primary">
                Cancel
            </Button>
            <Button onClick={handleAgree} color="primary" autoFocus>
                Confirm
            </Button>
            </DialogActions>
        </Dialog>
    );
}